import React, {createContext, PureComponent} from 'react';

export const TimerContext = createContext(null);

export class TimerProvider extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isRunning: false,
            totalDuration: 0,
            remainingSeconds: 0,
        };
        this.interval = null;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    startTimer = (duration) => {
        clearInterval(this.interval);

        this.setState({
            isRunning: true,
            totalDuration: duration,
            remainingSeconds: duration,
        });

        this.interval = setInterval(() => {
            this.setState(prev => {
                const next = prev.remainingSeconds - 1;
                if (next <= 0) {
                    clearInterval(this.interval);
                    this.onTimerEnd();
                    return { remainingSeconds: 0, isRunning: false };
                }
                return { remainingSeconds: next };
            });
        }, 1000);
    }

    pauseTimer = () => {
        clearInterval(this.interval);
        this.setState({ isRunning: false });
    }

    resumeTimer = () => {
        if (this.state.remainingSeconds <= 0) return;

        this.setState({ isRunning: true });

        this.interval = setInterval(() => {
            this.setState(prev => {
                const next = prev.remainingSeconds - 1;
                if (next <= 0) {
                    clearInterval(this.interval);
                    this.onTimerEnd();
                    return { remainingSeconds: 0, isRunning: false };
                }
                return { remainingSeconds: next };
            });
        }, 1000);
    }

    stopTimer = () => {
        clearInterval(this.interval);
        this.setState({ isRunning: false, remainingSeconds: 0, totalDuration: 0 });
    }

    completeTimer = () => {
        clearInterval(this.interval);
        this.onTimerEnd();
        this.setState({ isRunning: false, remainingSeconds: 0, totalDuration: 0 });
    }

    onTimerEnd = () => {
        const audio = new Audio('/countdown_beep.mp3');
        audio.play();
        window.navigator?.vibrate([300, 200, 300, 200, 300]);
        this.fireNotification();
    }

    fireNotification = () => {
        if (document.visibilityState === 'visible' && document.hasFocus()) return;

        if (!('Notification' in window) || Notification.permission !== 'granted') return;

        if (navigator.serviceWorker?.controller) {
            navigator.serviceWorker.ready.then(reg => {
                reg.showNotification('Timer Over', {
                    body: 'The timer is over',
                    icon: '/icon.png',
                    tag: 'rest-timer',
                    requireInteraction: true,
                });
            });
        } else {
            new Notification('Timer Over', {
                body: 'The timer is over',
                icon: '/icon.png',
                tag: 'rest-timer',
            });
        }
    }

    requestNotificationPermission = () => {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }

    render() {
        return (
            <TimerContext.Provider value={{
                isRunning: this.state.isRunning,
                totalDuration: this.state.totalDuration,
                remainingSeconds: this.state.remainingSeconds,
                startTimer: this.startTimer,
                pauseTimer: this.pauseTimer,
                resumeTimer: this.resumeTimer,
                stopTimer: this.stopTimer,
                completeTimer: this.completeTimer,
                requestNotificationPermission: this.requestNotificationPermission,
            }}>
                {this.props.children}
            </TimerContext.Provider>
        );
    }
}
